import { render, staticRenderFns } from "./c-list.vue?vue&type=template&id=2b36b20f&"
import script from "./c-list.vue?vue&type=script&lang=js&"
export * from "./c-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports